import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TabSyncService {
  private channel = new BroadcastChannel('pulpo-session');

  broadcastLogout(): void {
    this.channel.postMessage({ type: 'LOGOUT' });
  }

  broadcastTokenRefreshed(accessToken: string, refreshToken: string): void {
    this.channel.postMessage({ type: 'TOKEN_REFRESHED', accessToken, refreshToken });
  }

  listen(onLogout: () => void, onTokenRefreshed: (at: string, rt: string) => void): () => void {
    const handler = (e: MessageEvent) => {
      if (e.data?.type === 'LOGOUT') onLogout();
      if (e.data?.type === 'TOKEN_REFRESHED') onTokenRefreshed(e.data.accessToken, e.data.refreshToken);
    };
    this.channel.addEventListener('message', handler);
    return () => this.channel.removeEventListener('message', handler);
  }
}
